(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("hjWPk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "make", function () { return $c9c1d7ca3f1e702d$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $c9c1d7ca3f1e702d$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $c9c1d7ca3f1e702d$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $6SwLG = parcelRequire("6SwLG");

var $heivG = parcelRequire("heivG");

var $1BG9s = parcelRequire("1BG9s");

var $3gZOF = parcelRequire("3gZOF");

var $fvE4w = parcelRequire("fvE4w");

var $gFKzh = parcelRequire("gFKzh");

var $4XxBe = parcelRequire("4XxBe");

var $ePRCc = parcelRequire("ePRCc");

var $5bEXW = parcelRequire("5bEXW");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $lBn5n = parcelRequire("lBn5n");

var $2ZaET = parcelRequire("2ZaET");

var $2wB5I = parcelRequire("2wB5I");

var $dhngN = parcelRequire("dhngN");

var $8Esoa = parcelRequire("8Esoa");

var $8adqh = parcelRequire("8adqh");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");

var $eZ1bL = parcelRequire("eZ1bL");

var $g3aLS = parcelRequire("g3aLS");

var $h4qog = parcelRequire("h4qog");

var $gtaS4 = parcelRequire("gtaS4");

var $hM6fK = parcelRequire("hM6fK");

var $jQE31 = parcelRequire("jQE31");
function $c9c1d7ca3f1e702d$var$BottombarApp(Props) {
    var attributes = Props.attributes;
    var embedType = Props.embedType;
    var enabled = Props.enabled;
    var match = $g85JO.useState(function() {
        return true;
    });
    var setShouldDrawerShowShadow = match[1];
    var shouldDrawerShowShadow = match[0];
    var drawerContentRef = $g85JO.useRef(null);
    var scrollableContainerRef = $g85JO.useRef(null);
    var entrypointRef = $g85JO.useRef(null);
    var match$1 = $aSJcu.use(undefined);
    var breakpoint = match$1.breakpoint;
    var isMobile = match$1.isMobile;
    var match$2 = $8E2YL.use(undefined);
    var config = match$2.config;
    var match$3 = $fvE4w.use(undefined);
    var onCloseDrawer = match$3.onClose;
    var onOpenDrawer = match$3.onOpen;
    var onOpeningDrawer = match$3.onOpening;
    var drawerStateRef = match$3.stateRef;
    var drawerState = match$3.state;
    var match$4 = $hBcYV.useRouter(undefined);
    var isQuickView = match$4.isQuickView;
    var reset = match$4.reset;
    var quickViewUnderlyingRoute = match$4.quickViewUnderlyingRoute;
    var route = match$4.route;
    var enabled$1 = enabled || route !== /* NotRendered */ 0;
    var contextualRoot = $lBn5n.useContextualRoot(drawerState, embedType, window.location.pathname);
    var match$5 = $g85JO.useState(function() {
        return false;
    });
    var setScrollLocked = match$5[1];
    var scrollLocked = match$5[0];
    var scrollLockedRef = $g85JO.useRef(false);
    var trackEvent = $gFKzh.use(embedType);
    $g85JO.useEffect(function() {
        if (route !== /* NotRendered */ 0 && !isQuickView && drawerState !== /* Opening */ 1) $iv6Yc._1(onOpenDrawer, undefined);
        else if (route === /* NotRendered */ 0) $iv6Yc._1(onCloseDrawer, undefined);
    }, [
        route,
        drawerState
    ]);
    var anchorHookResult = $3gZOF.useAnchors(undefined, undefined);
    var handleDrawerStateChange = $g85JO.useCallback(function(isOpen) {
        if (isOpen) return $iv6Yc._1(onOpenDrawer, undefined);
        else {
            $iv6Yc._1(onCloseDrawer, undefined);
            return $iv6Yc._1(reset, undefined);
        }
    }, [
        reset
    ]);
    var handleScrollLock = function handleScrollLock(lock) {
        $iv6Yc._1(setScrollLocked, function(param) {
            return lock;
        });
        scrollLockedRef.current = lock;
    };
    var handleMenuVisibilityChange = $g85JO.useCallback(function(isVisible) {
        $iv6Yc._1(setShouldDrawerShowShadow, function(param) {
            return !isVisible;
        });
    }, []);
    var renderMainWrapper = function renderMainWrapper(children) {
        if (config.settings.smartbarEnabled) return /*#__PURE__*/ $g85JO.createElement($4XxBe.make, {
            enabled: drawerState === /* Closed */ 0 && config.settings.autoHideBottombar && isMobile,
            children: /*#__PURE__*/ $g85JO.createElement($6SwLG.make, {
                children: children,
                isOpen: drawerState === /* Open */ 2,
                scrollRef: scrollableContainerRef,
                onChangeState: handleDrawerStateChange,
                showDragIndicator: isMobile,
                showShadow: shouldDrawerShowShadow,
                fwdRef: $5bEXW.Ref.domRef(entrypointRef),
                onScrollLock: handleScrollLock
            })
        });
        else return /*#__PURE__*/ $g85JO.createElement($1BG9s.make, {
            children: children,
            isOpen: drawerState === /* Open */ 2,
            fwdRef: $5bEXW.Ref.domRef(entrypointRef)
        });
    };
    var openEventTriggered = $g85JO.useRef(false);
    $g85JO.useEffect(function() {
        var match = openEventTriggered.current;
        switch(drawerState){
            case /* Closed */ 0:
                openEventTriggered.current = false;
                break;
            case /* Opening */ 1:
                break;
            case /* Open */ 2:
                if (match) ;
                else {
                    $iv6Yc.app(trackEvent, [
                        "open",
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined
                    ]);
                    openEventTriggered.current = true;
                }
                break;
        }
    }, [
        drawerState,
        $hBcYV.toString(route)
    ]);
    var isPausingPageScroll = $2wB5I.useIsPausing(undefined);
    $g85JO.useEffect(function() {
        var handleTouchMove = function handleTouchMove(e) {
            if (isPausingPageScroll && drawerStateRef.current === /* Opening */ 1) {
                e.preventDefault();
                return;
            }
        };
        var addEventListener = function addEventListener(param) {
            window.addEventListener("touchmove", handleTouchMove, {
                capture: false,
                once: false,
                passive: false
            });
        };
        var removeEventListener = function removeEventListener(param) {
            window.removeEventListener("touchmove", handleTouchMove, {
                capture: false,
                passive: false
            });
        };
        addEventListener(undefined);
        return removeEventListener;
    }, [
        isPausingPageScroll
    ]);
    var renderContent = function renderContent(param) {
        if (!enabled$1) return null;
        var tmp = {
            config: config,
            embedType: embedType,
            onOpeningDrawer: onOpeningDrawer,
            children: null
        };
        if (attributes !== undefined) tmp.attributes = $loT9g.valFromOption(attributes);
        if (contextualRoot !== undefined) tmp.contextualRoot = $loT9g.valFromOption(contextualRoot);
        var tmp$1;
        var exit = 0;
        var exit$1 = 0;
        var exit$2 = 0;
        if (quickViewUnderlyingRoute !== undefined && !(typeof quickViewUnderlyingRoute === "number" || quickViewUnderlyingRoute.TAG !== /* PDP */ 2)) exit = 1;
        else exit$2 = 4;
        if (exit$2 === 4) {
            if (typeof route === "number" || route.TAG !== /* PDP */ 2) exit$1 = 3;
            else exit = 1;
        }
        if (exit$1 === 3) {
            if (quickViewUnderlyingRoute !== undefined && typeof quickViewUnderlyingRoute !== "number") switch(quickViewUnderlyingRoute.TAG | 0){
                case /* Home */ 0:
                case /* ListPage */ 1:
                case /* QuickView */ 3:
                    exit = 2;
                    break;
            }
            else exit = 2;
        }
        switch(exit){
            case 1:
                tmp$1 = /*#__PURE__*/ $g85JO.createElement($hM6fK.make, {
                    viewport: entrypointRef,
                    scrollableContainerRef: scrollableContainerRef,
                    shouldForceMobile: (config.settings.panelSize === /* Small */ 2 || config.settings.panelSize === /* Medium */ 1 && breakpoint <= /* Lg */ 3) && !config.settings.smartbarEnabled
                });
                break;
            case 2:
                var tmp$2;
                var exit$3 = 0;
                var exit$4 = 0;
                if (quickViewUnderlyingRoute !== undefined) {
                    if (typeof quickViewUnderlyingRoute === "number") exit$3 = 3;
                    else switch(quickViewUnderlyingRoute.TAG | 0){
                        case /* PDP */ 2:
                        case /* QuickView */ 3:
                            exit$4 = 4;
                            break;
                        default:
                            exit$3 = 3;
                    }
                } else exit$4 = 4;
                if (exit$4 === 4) {
                    if (typeof route === "number") exit$3 = 3;
                    else switch(route.TAG | 0){
                        case /* PDP */ 2:
                        case /* QuickView */ 3:
                            tmp$2 = null;
                            break;
                        default:
                            exit$3 = 3;
                    }
                }
                if (exit$3 === 3) tmp$2 = /*#__PURE__*/ $g85JO.createElement($heivG.make, {
                    drawerState: drawerState,
                    embedType: embedType,
                    onHoverMenuVisibilityChanged: handleMenuVisibilityChange
                });
                tmp$1 = /*#__PURE__*/ $g85JO.createElement($h4qog.make, {
                    scrollableContainerRef: scrollableContainerRef,
                    drawerState: drawerState,
                    anchorHookResult: anchorHookResult,
                    children: tmp$2
                });
                break;
        }
        var tmp$3;
        tmp$3 = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? null : /*#__PURE__*/ $g85JO.createElement($b8WNX.make, {});
        return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
            initiator: "bottombar",
            className: $ezf3v.prefix("smartnav-bottombar"),
            portal: true,
            children: /*#__PURE__*/ $g85JO.createElement($dhngN.make, tmp, /*#__PURE__*/ $g85JO.createElement($8Esoa.make, {
                embedType: embedType
            }), /*#__PURE__*/ $g85JO.createElement($fvE4w.Provider.make, {
                value: drawerState,
                children: null
            }, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: scrollLocked || drawerState === /* Opening */ 1 || drawerState === /* Open */ 2 || isQuickView,
                children: /*#__PURE__*/ $g85JO.createElement($2wB5I.make, {})
            }), /*#__PURE__*/ $g85JO.createElement($g3aLS.make, {
                children: /*#__PURE__*/ $g85JO.createElement($jQE31.make, {
                    onChange: function onChange(param) {
                        $iv6Yc._1(anchorHookResult.setOffset, param.anchorsOffset);
                    },
                    scrollableContainerRef: scrollableContainerRef,
                    autoHidePrimaryNavbar: isMobile,
                    children: renderMainWrapper(/*#__PURE__*/ $g85JO.createElement("div", {
                        ref: $5bEXW.Ref.domRef(drawerContentRef),
                        className: $ezf3v.prefix("flex flex-col-reverse flex-grow")
                    }, tmp$1))
                })
            }), tmp$3, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: config.settings.cart,
                children: /*#__PURE__*/ $g85JO.createElement($8adqh.make, {})
            })))
        });
    };
    var pictureInPicture = config.settings.quickviewPictureInPicture;
    return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: pictureInPicture,
        children: /*#__PURE__*/ $g85JO.createElement($gtaS4.make, {
            children: null
        }, renderContent(undefined), /*#__PURE__*/ $g85JO.createElement($eZ1bL.make, {})),
        fallback: renderContent(undefined)
    });
}
$c9c1d7ca3f1e702d$var$BottombarApp.displayName = "BottombarApp";
var $c9c1d7ca3f1e702d$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($c9c1d7ca3f1e702d$var$BottombarApp);
var $c9c1d7ca3f1e702d$export$aa541d093b11ace2 = $c9c1d7ca3f1e702d$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("1BG9s", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $12b9f191daa66153$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $7wIsS = parcelRequire("7wIsS");

var $lhKg5 = parcelRequire("lhKg5");

var $27XcH = parcelRequire("27XcH");

var $849Xu = parcelRequire("849Xu");

var $2jMpY = parcelRequire("2jMpY");

var $6Ntmr = parcelRequire("6Ntmr");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $lihS4 = parcelRequire("lihS4");

var $8E2YL = parcelRequire("8E2YL");
function $12b9f191daa66153$var$SidePanel(Props) {
    var children = Props.children;
    var isOpen = Props.isOpen;
    var fwdRef = Props.fwdRef;
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var match$1 = $aSJcu.use(undefined);
    var isMobile = match$1.isMobile;
    var match$2 = $9pMGg.use(undefined);
    var onCloseNavigation = match$2.onCloseNavigation;
    var onHomeClick = match$2.onHomeClick;
    var match$3 = $lihS4.useCart(undefined);
    var cart = match$3.cart;
    var isInlineNav = match$2.embedType === /* Inline */ 1;
    var onExit = $g85JO.useCallback(function(param) {
        $iv6Yc._1(onCloseNavigation, undefined);
    }, [
        onCloseNavigation
    ]);
    var onHome = $g85JO.useCallback(function(param) {
        $iv6Yc._1(onHomeClick, undefined);
    }, [
        onHomeClick
    ]);
    var match$4 = settings.panelSize;
    var openPosition = $1TRFX.make([
        match$4 !== 2 && match$1.breakpoint >= 2 ? "translate-x-0 opacity-100" : "translate-x-0",
        "pointer-events-auto ease-out-cubic"
    ]);
    var match$5 = settings.panelSize;
    var tmp;
    var exit = 0;
    if (match$5 !== 2 && !isMobile) {
        var match$6 = settings.panelPosition;
        tmp = match$6 ? "translate-x-16 opacity-0" : "-translate-x-16 opacity-0";
    } else exit = 1;
    if (exit === 1) {
        var match$7 = settings.panelPosition;
        tmp = match$7 ? "translate-x-full" : "-translate-x-full";
    }
    var closePosition = $1TRFX.make([
        tmp,
        "pointer-events-none ease-in-out-quint"
    ]);
    var match$8 = settings.panelPosition;
    var buttonPositionClassName = match$8 ? "left-0 -ml-16" : "right-0 -mr-16";
    var minWidth;
    if (isMobile || isInlineNav) minWidth = "0px";
    else {
        var match$9 = settings.panelSize;
        minWidth = match$9 >= 3 ? "100%" : "540px";
    }
    var width;
    if (isMobile || isInlineNav) width = "100%";
    else {
        var match$10 = settings.panelSize;
        switch(match$10){
            case /* Large */ 0:
                width = "90%";
                break;
            case /* Medium */ 1:
                width = "60%";
                break;
            case /* Small */ 2:
                width = minWidth;
                break;
            case /* FullWidth */ 3:
                width = "100%";
                break;
        }
    }
    var negWidth;
    if (isMobile || isInlineNav) negWidth = "0%";
    else {
        var match$11 = settings.panelSize;
        switch(match$11){
            case /* Large */ 0:
                negWidth = "10%";
                break;
            case /* Medium */ 1:
                negWidth = "40%";
                break;
            case /* Small */ 2:
                negWidth = "" + String(match$1.windowSize.width - 540 | 0) + "px";
                break;
            case /* FullWidth */ 3:
                negWidth = "0%";
                break;
        }
    }
    var match$12 = settings.backdrop;
    var match$13 = settings.backdropBlur;
    var wrapperPointerClassName = isOpen ? match$12 || match$13 || isInlineNav ? "pointer-events-auto" : "pointer-events-none" : isInlineNav ? "pointer-events-auto" : "pointer-events-none";
    var wrapperClassName = $ezf3v.prefix($1TRFX.make([
        "w-full h-full fixed top-0 left-0",
        wrapperPointerClassName
    ]));
    var match$14 = settings.panelPosition;
    var panelPositionClassName = isInlineNav ? "relative" : match$14 ? "absolute top-0 right-0" : "absolute top-0 left-0";
    var panelShadowClassName = isInlineNav ? "" : "shadow-lg";
    var panelTransitionClassName = isInlineNav ? "" : "transition-all transform-gpu duration-150 " + (isOpen ? openPosition : closePosition);
    var panelClassName = $ezf3v.prefix($1TRFX.make([
        "bg-main h-full flex flex-col w-full",
        panelTransitionClassName,
        panelPositionClassName,
        panelShadowClassName
    ]));
    var panelContentPositionClassName = isInlineNav ? "" : "absolute inset-0";
    var panelContentClassName = $ezf3v.prefix($1TRFX.make([
        "flex flex-col w-full h-full",
        panelContentPositionClassName,
        isOpen ? "" : "overflow-hidden"
    ]));
    var backdropFilter = $ezf3v.prefix($1TRFX.make([
        "absolute top-0 h-full",
        settings.backdropBlur ? "backdrop-blur-xs-clear" : "",
        settings.panelPosition === /* Left */ 0 ? "right-0" : "left-0"
    ]));
    var renderButtons = function renderButtons(param) {
        var renderCloseButton = function renderCloseButton(param) {
            return /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
                onClick: onExit,
                dark: true,
                icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {
                    size: /* Px */ {
                        _0: 22
                    }
                }),
                title: "Close",
                className: $ezf3v.prefix("relative")
            });
        };
        var renderCheckoutButton = function renderCheckoutButton(param) {
            var href = settings.checkoutLink;
            if (href === undefined) return null;
            var tmp = {
                dark: !isMobile,
                icon: /*#__PURE__*/ $g85JO.createElement($lhKg5.make, {
                    size: 20
                }),
                title: "Checkout"
            };
            var tmp$1 = $2jMpY.fromInt(99, undefined, cart.itemCount);
            if (tmp$1 !== undefined) tmp.badge = $loT9g.valFromOption(tmp$1);
            return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
                children: null,
                href: href,
                className: $ezf3v.prefix("relative")
            }, /*#__PURE__*/ $g85JO.createElement($27XcH.make, tmp), /*#__PURE__*/ $g85JO.createElement($6Ntmr.make, {
                productDirection: settings.panelPosition === /* Left */ 0 ? /* Left */ 2 : /* Right */ 3,
                tooltipDirection: settings.panelPosition === /* Left */ 0 ? /* Left */ 2 : /* Right */ 3,
                addedLabel: settings.pdpAddToCartConfirmation,
                className: $ezf3v.prefix("absolute w-full h-full"),
                enabled: !isMobile
            }));
        };
        var renderHomeButton = function renderHomeButton(param) {
            return /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
                onClick: onHome,
                dark: true,
                icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilEstate.make, {
                    size: /* Px */ {
                        _0: 20
                    }
                }),
                title: "Home",
                className: $ezf3v.prefix("relative")
            });
        };
        var match = settings.panelSize;
        if (isInlineNav || match >= 3 || isMobile) return null;
        else return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "absolute top-0 mt-4 flex flex-col space-y-4",
                buttonPositionClassName,
                settings.panelPosition === /* Left */ 0 ? "right-0" : "left-0"
            ]))
        }, renderCloseButton(undefined), renderCheckoutButton(undefined), renderHomeButton(undefined));
    };
    var renderBackdrop = function renderBackdrop(param) {
        var match = settings.backdrop;
        var match$1 = settings.backdropBlur;
        if (match) {
            if (isMobile) return null;
            if (isInlineNav) return null;
        } else {
            if (!match$1) return null;
            if (isMobile) return null;
            if (isInlineNav) return null;
        }
        return /*#__PURE__*/ $g85JO.createElement("div", {
            onClick: onExit
        }, /*#__PURE__*/ $g85JO.createElement($849Xu.make, {
            show: isOpen,
            enter: $ezf3v.prefix("transition-opacity duration-150 ease-in-out"),
            enterFrom: $ezf3v.prefix("opacity-0"),
            enterTo: $ezf3v.prefix("opacity-100"),
            leave: $ezf3v.prefix("transition-opacity duration-150 ease-in-out"),
            leaveFrom: $ezf3v.prefix("opacity-100"),
            leaveTo: $ezf3v.prefix("opacity-0"),
            className: $ezf3v.prefix("absolute inset-0"),
            style: {
                backgroundColor: settings.backdropColor
            }
        }), /*#__PURE__*/ $g85JO.createElement($849Xu.make, {
            show: isOpen,
            enter: $ezf3v.prefix("transition-opacity duration-150 delay-300 ease-in-out"),
            enterFrom: $ezf3v.prefix("opacity-0"),
            enterTo: $ezf3v.prefix("opacity-100"),
            leave: $ezf3v.prefix("transition-opacity duration-150 ease-in-out"),
            leaveFrom: $ezf3v.prefix("opacity-100"),
            leaveTo: $ezf3v.prefix("opacity-0"),
            className: backdropFilter,
            style: {
                width: negWidth
            }
        }));
    };
    var tmp$1 = {
        className: panelClassName,
        style: {
            minWidth: minWidth,
            width: width
        }
    };
    if (fwdRef !== undefined) tmp$1.ref = $loT9g.valFromOption(fwdRef);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: wrapperClassName,
        style: {
            zIndex: settings.zIndex
        }
    }, renderBackdrop(undefined), /*#__PURE__*/ $g85JO.createElement("div", tmp$1, /*#__PURE__*/ $g85JO.createElement("div", {
        className: panelContentClassName
    }, children, renderButtons(undefined))));
}
$12b9f191daa66153$var$SidePanel.displayName = "SidePanel";
var $12b9f191daa66153$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($12b9f191daa66153$var$SidePanel);
 /* make Not a pure module */ 
});

parcelRegister("fvE4w", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $b4a8d5b63998f43c$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "Provider", function () { return $b4a8d5b63998f43c$export$2881499e37b75b9a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");
function $b4a8d5b63998f43c$export$1f96ae73734a86cc(param) {
    var match = $g85JO.useState(function() {
        return /* Closed */ 0;
    });
    var setState = match[1];
    var stateRef = $g85JO.useRef(/* Closed */ 0);
    var handleChange = function handleChange(next) {
        $iv6Yc._1(setState, function(param) {
            return next;
        });
        stateRef.current = next;
    };
    var onClose = function onClose(param) {
        handleChange(/* Closed */ 0);
    };
    var onOpen = function onOpen(param) {
        handleChange(/* Open */ 2);
    };
    var onOpening = function onOpening(param) {
        handleChange(/* Opening */ 1);
    };
    return {
        state: match[0],
        stateRef: stateRef,
        onOpening: onOpening,
        onOpen: onOpen,
        onClose: onClose
    };
}
var $b4a8d5b63998f43c$var$context = /*#__PURE__*/ $g85JO.createContext(/* Closed */ 0);
var $b4a8d5b63998f43c$var$provider = $b4a8d5b63998f43c$var$context.Provider;
function $b4a8d5b63998f43c$var$DrawerState$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($b4a8d5b63998f43c$var$provider, {
        value: value,
        children: children
    });
}
$b4a8d5b63998f43c$var$DrawerState$Provider.displayName = "DrawerState.Provider";
function $b4a8d5b63998f43c$var$use$1(param) {
    return $g85JO.useContext($b4a8d5b63998f43c$var$context);
}
var $b4a8d5b63998f43c$export$2881499e37b75b9a = {
    context: $b4a8d5b63998f43c$var$context,
    provider: $b4a8d5b63998f43c$var$provider,
    make: $b4a8d5b63998f43c$var$DrawerState$Provider,
    use: $b4a8d5b63998f43c$var$use$1
};
 /* context Not a pure module */ 
});

parcelRegister("lBn5n", function(module, exports) {

$parcel$export(module.exports, "useContextualRoot", function () { return $fb9ef608eb76e9b2$export$fd42e504a4d8f825; });
$parcel$export(module.exports, "useContextualL1s", function () { return $fb9ef608eb76e9b2$export$f20aa461418ac738; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $bygWp = parcelRequire("bygWp");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $fb9ef608eb76e9b2$export$b829272b1dcc6798(url) {
    try {
        return $2whNH.map($2whNH.map($bygWp.maybeMakeUrl(url), function(prim) {
            return prim.pathname;
        }), function(prim) {
            return prim.toLowerCase();
        });
    } catch (exn) {
        return;
    }
}
function $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories) {
    if (urlPathname === "/") return;
    var l1Match = topLevelCategories.find(function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var link = $1xf0g.getCategoryLink(cat);
        if (link !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(link));
        else return false;
    });
    var l1Match$1 = l1Match === undefined ? undefined : $loT9g.some(l1Match);
    var l2OrDeeperMatch = $1xf0g.findCategoryBy(topLevelCategories, function(cat) {
        if (!(!$1xf0g.isQuickView(cat) && !$1xf0g.isLinkCategory(cat) && !$1xf0g.hasMedialessCard(cat))) return false;
        var match = $1xf0g.getCategoryLink(cat);
        if (l1Match !== undefined) {
            if (match !== undefined && $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match))) return l1Match.id !== cat.id;
            else return false;
        } else if (match !== undefined) return $7bjme.equal(urlPathname.toLowerCase(), $fb9ef608eb76e9b2$export$b829272b1dcc6798(match));
        else return false;
    });
    if (l2OrDeeperMatch !== undefined) return l2OrDeeperMatch;
    else return l1Match$1;
}
function $fb9ef608eb76e9b2$export$7f3d9773c89e0196(topLevelCategories, category) {
    return $1xf0g.getCategoryParentById(topLevelCategories, category.id);
}
function $fb9ef608eb76e9b2$export$2b5083f21a7660c3(categories, fallback) {
    if ($i7mYY.keep(categories, function(category) {
        return category.visibleInMenuBar;
    }).length === 0) return fallback;
    else return categories;
}
function $fb9ef608eb76e9b2$export$fd42e504a4d8f825(drawerState, embedType, urlPathname) {
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var canUseContextualL1s = embedType !== /* Inline */ 1 && settings.contextualL1s && drawerState !== /* Open */ 2 || settings.contextualInline && embedType === /* Inline */ 1;
    if (canUseContextualL1s) return $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, match.categories);
}
function $fb9ef608eb76e9b2$export$f20aa461418ac738(embedType, drawerState, urlPathname) {
    var hasNavigatedAwayFromContextualRoot = $g85JO.useRef(false);
    var match = $8E2YL.use(undefined).config;
    var topLevelCategories = match.categories;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, topLevelCategories);
    var canUseContextualL1s = (embedType === /* Bottombar */ 0 || embedType === /* Launcher */ 2) && match.settings.contextualL1s && drawerState !== /* Open */ 2;
    if (!canUseContextualL1s) return topLevelCategories;
    var contextualRoot = $fb9ef608eb76e9b2$export$1e0981608463ce2(urlPathname, topLevelCategories);
    var isInRootsOrParentPath;
    if (contextualRoot !== undefined) {
        var isRootPLP = $1xf0g.isPLP(contextualRoot);
        var inRootsPath = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
            return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
        }).some(function(cat) {
            return cat.id === contextualRoot.id;
        });
        if (inRootsPath) isInRootsOrParentPath = true;
        else {
            var tmp = false;
            if (isRootPLP) {
                var rootParent = $1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id);
                tmp = $2whNH.mapWithDefault(activeCategory, [], function(activeCat) {
                    return $1xf0g.getCategoryPathById(topLevelCategories, activeCat.id);
                }).some(function(cat) {
                    return cat.id === $2whNH.mapWithDefault(rootParent, "", function(parent) {
                        return parent.id;
                    });
                });
            }
            isInRootsOrParentPath = tmp;
        }
    } else isInRootsOrParentPath = false;
    if (!isInRootsOrParentPath && drawerState === /* Open */ 2) hasNavigatedAwayFromContextualRoot.current = true;
    if (drawerState === /* Closed */ 0) hasNavigatedAwayFromContextualRoot.current = false;
    var canUseContextualL1s$1 = canUseContextualL1s && (drawerState === /* Closed */ 0 || isInRootsOrParentPath) && (drawerState === /* Closed */ 0 || !hasNavigatedAwayFromContextualRoot.current);
    if (contextualRoot === undefined) return topLevelCategories;
    if (!canUseContextualL1s$1) return topLevelCategories;
    var match$1 = contextualRoot.listPageActiveLayout;
    var isPLP;
    isPLP = typeof match$1 === "number" || match$1.TAG !== /* ProductGrid */ 3 ? false : true;
    if (isPLP) return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($2whNH.mapWithDefault($1xf0g.getCategoryParentById(topLevelCategories, contextualRoot.id), topLevelCategories, $1xf0g.getChildren), topLevelCategories);
    else return $fb9ef608eb76e9b2$export$2b5083f21a7660c3($1xf0g.getChildren(contextualRoot), topLevelCategories);
}
 /* react Not a pure module */ 
});

parcelRegister("8adqh", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $5f19ab6e1e369baa$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $5f19ab6e1e369baa$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("gYFXa"));
});
function $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($5f19ab6e1e369baa$var$component, Props);
}
$5f19ab6e1e369baa$var$MiniCartDrawer_Lazy.displayName = "MiniCartDrawer_Lazy";
var $5f19ab6e1e369baa$export$dd44f18ab656f3bb = $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("gYFXa", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fsMVk")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("ebd07"))
]).then(function() {
    return parcelRequire("67Br4");
});

});


parcelRegister("b8WNX", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $81ce0e7d77235b59$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $81ce0e7d77235b59$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $81ce0e7d77235b59$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("2zB6y"));
});
function $81ce0e7d77235b59$var$QuickViewOverlay_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($81ce0e7d77235b59$var$component, Props);
}
$81ce0e7d77235b59$var$QuickViewOverlay_Lazy.displayName = "QuickViewOverlay_Lazy";
var $81ce0e7d77235b59$export$513ccb98c53b8039 = $81ce0e7d77235b59$var$component.preload;
var $81ce0e7d77235b59$export$dd44f18ab656f3bb = $81ce0e7d77235b59$var$QuickViewOverlay_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("2zB6y", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1YO94")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fsMVk")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("3pqCl"))
]).then(function() {
    return parcelRequire("1xMeg");
});

});


parcelRegister("gtaS4", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $bfd7c98ffbabf0bf$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "make", function () { return $bfd7c98ffbabf0bf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d1G6W = parcelRequire("d1G6W");

var $2whNH = parcelRequire("2whNH");

var $kJhYp = parcelRequire("kJhYp");

var $ckFDW = parcelRequire("ckFDW");

var $efwy1 = parcelRequire("efwy1");

var $hm3Un = parcelRequire("hm3Un");
var $bfd7c98ffbabf0bf$export$2cd8252107eb640b = {
    mediaId: undefined,
    aspectRatio: undefined,
    backLocation: undefined,
    time: undefined,
    muted: false,
    setMediaId: undefined,
    saveTime: undefined,
    setMuted: undefined
};
var $bfd7c98ffbabf0bf$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext($bfd7c98ffbabf0bf$export$2cd8252107eb640b);
var $bfd7c98ffbabf0bf$var$provider = $bfd7c98ffbabf0bf$export$a078c61943f9dbbe.Provider;
function $bfd7c98ffbabf0bf$var$PictureInPictureContext$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($bfd7c98ffbabf0bf$var$provider, {
        value: value,
        children: children
    });
}
$bfd7c98ffbabf0bf$var$PictureInPictureContext$Provider.displayName = "PictureInPictureContext.Provider";
var $bfd7c98ffbabf0bf$export$2881499e37b75b9a = {
    provider: $bfd7c98ffbabf0bf$var$provider,
    make: $bfd7c98ffbabf0bf$var$PictureInPictureContext$Provider
};
function $bfd7c98ffbabf0bf$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($bfd7c98ffbabf0bf$export$a078c61943f9dbbe);
}
function $bfd7c98ffbabf0bf$var$PictureInPictureContext(Props) {
    var children = Props.children;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var match$1 = $g85JO.useState(function() {
        return $hm3Un.getFromSessionStorage("mediaId");
    });
    var setMediaId = match$1[1];
    var mediaId = match$1[0];
    var match$2 = $g85JO.useState(function() {
        return $2whNH.flatMap($hm3Un.getFromSessionStorage("aspectRatio"), $d1G6W.fromString);
    });
    var setAspectRatio = match$2[1];
    var aspectRatio = match$2[0];
    var match$3 = $g85JO.useState(function() {
        return $2whNH.isSome($hm3Un.getFromSessionStorage("mediaId"));
    });
    var setMuted = match$3[1];
    var muted = match$3[0];
    var match$4 = $g85JO.useState(function() {
        return $2whNH.flatMap($hm3Un.getFromSessionStorage("time"), $d1G6W.fromString);
    });
    var setTime = match$4[1];
    var time = match$4[0];
    var match$5 = $g85JO.useState(function() {
        return $2whNH.map($hm3Un.getFromSessionStorage("backLocation"), function(param) {
            return $kJhYp.fromUrl(namespace, param);
        });
    });
    var setBackLocation = match$5[1];
    var backLocation = match$5[0];
    $g85JO.useEffect(function() {
        $hm3Un.setToSessionStorage("mediaId", $2whNH.getWithDefault(mediaId, ""));
    }, [
        mediaId
    ]);
    $g85JO.useEffect(function() {
        $hm3Un.setToSessionStorage("aspectRatio", $2whNH.mapWithDefault(aspectRatio, "", function(prim) {
            return String(prim);
        }));
    }, [
        aspectRatio
    ]);
    $g85JO.useEffect(function() {
        $hm3Un.setToSessionStorage("time", $2whNH.mapWithDefault(time, "", function(prim) {
            return String(prim);
        }));
    }, [
        time
    ]);
    $g85JO.useEffect(function() {
        $hm3Un.setToSessionStorage("backLocation", $2whNH.mapWithDefault(backLocation, "", function(loc) {
            return window.location.origin + "?" + $kJhYp.toQueryString(namespace, loc);
        }));
    }, [
        backLocation
    ]);
    var saveTime = (0, $ckFDW.default)(function(time) {
        $hm3Un.setToSessionStorage("time", String(time));
    }, 3000);
    var value = $g85JO.useMemo(function() {
        return {
            mediaId: mediaId,
            aspectRatio: aspectRatio,
            backLocation: backLocation,
            time: time,
            muted: muted,
            setMediaId: function setMediaId1(backLocation, time, aspectRatio, mutedOpt, mediaId) {
                var muted = mutedOpt !== undefined ? mutedOpt : false;
                if (mediaId !== undefined) {
                    if (backLocation !== undefined) {
                        var location_quickView = {
                            mediaId: mediaId,
                            mediaParentId: backLocation.quickView.mediaParentId,
                            albumId: undefined,
                            panelClosed: undefined,
                            whichList: undefined,
                            productId: undefined,
                            relatedMediaProductIds: backLocation.quickView.relatedMediaProductIds,
                            relatedMediaCategoryId: backLocation.quickView.relatedMediaCategoryId,
                            variantId: undefined,
                            photoZoom: undefined,
                            time: undefined
                        };
                        var location_quickNav = backLocation.quickNav;
                        var $$location = {
                            quickView: location_quickView,
                            quickNav: location_quickNav
                        };
                        $iv6Yc._1(setBackLocation, function(param) {
                            return $$location;
                        });
                    } else {
                        var $$location$1 = $kJhYp.fromUrl(namespace, window.location.href);
                        $kJhYp.goTo(namespace, undefined, undefined, $$location$1.quickNav, undefined, undefined, undefined);
                        $iv6Yc._1(setBackLocation, function(param) {
                            return $$location$1;
                        });
                    }
                } else if (backLocation !== undefined) {
                    var quickView = backLocation.quickView;
                    var quickView_mediaId = quickView.mediaId;
                    var quickView_mediaParentId = quickView.mediaParentId;
                    var quickView_albumId = quickView.albumId;
                    var quickView_panelClosed = quickView.panelClosed;
                    var quickView_whichList = quickView.whichList;
                    var quickView_productId = quickView.productId;
                    var quickView_relatedMediaProductIds = quickView.relatedMediaProductIds;
                    var quickView_relatedMediaCategoryId = quickView.relatedMediaCategoryId;
                    var quickView_variantId = quickView.variantId;
                    var quickView_photoZoom = quickView.photoZoom;
                    var quickView$1 = {
                        mediaId: quickView_mediaId,
                        mediaParentId: quickView_mediaParentId,
                        albumId: quickView_albumId,
                        panelClosed: quickView_panelClosed,
                        whichList: quickView_whichList,
                        productId: quickView_productId,
                        relatedMediaProductIds: quickView_relatedMediaProductIds,
                        relatedMediaCategoryId: quickView_relatedMediaCategoryId,
                        variantId: quickView_variantId,
                        photoZoom: quickView_photoZoom,
                        time: time
                    };
                    $kJhYp.goTo(namespace, undefined, quickView$1, backLocation.quickNav, undefined, undefined, undefined);
                    $iv6Yc._1(setBackLocation, function(param) {});
                } else $iv6Yc._1(setBackLocation, function(param) {});
                $iv6Yc._1(setMediaId, function(param) {
                    return mediaId;
                });
                $iv6Yc._1(setTime, function(param) {
                    return time;
                });
                $iv6Yc._1(setMuted, function(param) {
                    return muted;
                });
                if (aspectRatio !== undefined) return $iv6Yc._1(setAspectRatio, function(param) {
                    return aspectRatio;
                });
            },
            saveTime: saveTime,
            setMuted: function setMuted1(value) {
                $iv6Yc._1(setMuted, function(param) {
                    return value;
                });
            }
        };
    }, [
        mediaId,
        aspectRatio,
        $2whNH.map(backLocation, function(param) {
            return $kJhYp.toQueryString(namespace, param);
        }),
        time,
        muted
    ]);
    return /*#__PURE__*/ $g85JO.createElement($bfd7c98ffbabf0bf$var$PictureInPictureContext$Provider, {
        value: value,
        children: children
    });
}
$bfd7c98ffbabf0bf$var$PictureInPictureContext.displayName = "PictureInPictureContext";
var $bfd7c98ffbabf0bf$export$dd44f18ab656f3bb = $bfd7c98ffbabf0bf$var$PictureInPictureContext;
 /* context Not a pure module */ 
});
parcelRegister("ckFDW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa7a7c95612752e$export$2e2bcd8739ae039; });

var $g0DOt = parcelRequire("g0DOt");

var $iYlcu = parcelRequire("iYlcu");
/** Error message constants. */ var $8fa7a7c95612752e$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $8fa7a7c95612752e$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($8fa7a7c95612752e$var$FUNC_ERROR_TEXT);
    if ((0, $iYlcu.default)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $g0DOt.default)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $8fa7a7c95612752e$export$2e2bcd8739ae039 = $8fa7a7c95612752e$var$throttle;

});
parcelRegister("g0DOt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba7b877d63b6054e$export$2e2bcd8739ae039; });

var $iYlcu = parcelRequire("iYlcu");

var $92qkg = parcelRequire("92qkg");

var $flcGD = parcelRequire("flcGD");
/** Error message constants. */ var $ba7b877d63b6054e$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ba7b877d63b6054e$var$nativeMax = Math.max, $ba7b877d63b6054e$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ba7b877d63b6054e$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($ba7b877d63b6054e$var$FUNC_ERROR_TEXT);
    wait = (0, $flcGD.default)(wait) || 0;
    if ((0, $iYlcu.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $ba7b877d63b6054e$var$nativeMax((0, $flcGD.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ba7b877d63b6054e$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $92qkg.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $92qkg.default)());
    }
    function debounced() {
        var time = (0, $92qkg.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $ba7b877d63b6054e$export$2e2bcd8739ae039 = $ba7b877d63b6054e$var$debounce;

});
parcelRegister("iYlcu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcfe469055918527$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $gfRPo = parcelRequire("gfRPo");
function $dcfe469055918527$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $gfRPo._)(value);
    return value != null && (type == "object" || type == "function");
}
var $dcfe469055918527$export$2e2bcd8739ae039 = $dcfe469055918527$var$isObject;

});

parcelRegister("92qkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6948b8bba5c9c483$export$2e2bcd8739ae039; });

var $enmTs = parcelRequire("enmTs");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6948b8bba5c9c483$var$now = function now() {
    return (0, $enmTs.default).Date.now();
};
var $6948b8bba5c9c483$export$2e2bcd8739ae039 = $6948b8bba5c9c483$var$now;

});
parcelRegister("enmTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02b36f5e631d88f5$export$2e2bcd8739ae039; });

var $igP3b = parcelRequire("igP3b");
/** Detect free variable `self`. */ var $02b36f5e631d88f5$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $02b36f5e631d88f5$var$root = (0, $igP3b.default) || $02b36f5e631d88f5$var$freeSelf || Function("return this")();
var $02b36f5e631d88f5$export$2e2bcd8739ae039 = $02b36f5e631d88f5$var$root;

});
parcelRegister("igP3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4d152269e8defce$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $d4d152269e8defce$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $d4d152269e8defce$export$2e2bcd8739ae039 = $d4d152269e8defce$var$freeGlobal;

});



parcelRegister("flcGD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b2a881acb233f6$export$2e2bcd8739ae039; });

var $7bKHP = parcelRequire("7bKHP");

var $iYlcu = parcelRequire("iYlcu");

var $9WZwf = parcelRequire("9WZwf");
/** Used as references for various `Number` constants. */ var $b2b2a881acb233f6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $b2b2a881acb233f6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b2b2a881acb233f6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b2b2a881acb233f6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b2b2a881acb233f6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b2b2a881acb233f6$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $9WZwf.default)(value)) return $b2b2a881acb233f6$var$NAN;
    if ((0, $iYlcu.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $iYlcu.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $7bKHP.default)(value);
    var isBinary = $b2b2a881acb233f6$var$reIsBinary.test(value);
    return isBinary || $b2b2a881acb233f6$var$reIsOctal.test(value) ? $b2b2a881acb233f6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b2b2a881acb233f6$var$reIsBadHex.test(value) ? $b2b2a881acb233f6$var$NAN : +value;
}
var $b2b2a881acb233f6$export$2e2bcd8739ae039 = $b2b2a881acb233f6$var$toNumber;

});
parcelRegister("7bKHP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53bdca4c640065b2$export$2e2bcd8739ae039; });

var $hVIkI = parcelRequire("hVIkI");
/** Used to match leading whitespace. */ var $53bdca4c640065b2$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $53bdca4c640065b2$var$baseTrim(string) {
    return string ? string.slice(0, (0, $hVIkI.default)(string) + 1).replace($53bdca4c640065b2$var$reTrimStart, "") : string;
}
var $53bdca4c640065b2$export$2e2bcd8739ae039 = $53bdca4c640065b2$var$baseTrim;

});
parcelRegister("hVIkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0da26260aa88ea2$export$2e2bcd8739ae039; });
/** Used to match a single whitespace character. */ var $d0da26260aa88ea2$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d0da26260aa88ea2$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d0da26260aa88ea2$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $d0da26260aa88ea2$export$2e2bcd8739ae039 = $d0da26260aa88ea2$var$trimmedEndIndex;

});


parcelRegister("9WZwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e9403b864b7e92$export$2e2bcd8739ae039; });

var $gfRPo = parcelRequire("gfRPo");

var $gEvC5 = parcelRequire("gEvC5");

var $2pW4B = parcelRequire("2pW4B");
/** `Object#toString` result references. */ var $73e9403b864b7e92$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $73e9403b864b7e92$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $gfRPo._)(value)) == "symbol" || (0, $2pW4B.default)(value) && (0, $gEvC5.default)(value) == $73e9403b864b7e92$var$symbolTag;
}
var $73e9403b864b7e92$export$2e2bcd8739ae039 = $73e9403b864b7e92$var$isSymbol;

});
parcelRegister("gEvC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1f8e78702c28b95$export$2e2bcd8739ae039; });

var $155hF = parcelRequire("155hF");

var $drSKx = parcelRequire("drSKx");

var $gu259 = parcelRequire("gu259");
/** `Object#toString` result references. */ var $c1f8e78702c28b95$var$nullTag = "[object Null]", $c1f8e78702c28b95$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $c1f8e78702c28b95$var$symToStringTag = (0, $155hF.default) ? (0, $155hF.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c1f8e78702c28b95$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c1f8e78702c28b95$var$undefinedTag : $c1f8e78702c28b95$var$nullTag;
    return $c1f8e78702c28b95$var$symToStringTag && $c1f8e78702c28b95$var$symToStringTag in Object(value) ? (0, $drSKx.default)(value) : (0, $gu259.default)(value);
}
var $c1f8e78702c28b95$export$2e2bcd8739ae039 = $c1f8e78702c28b95$var$baseGetTag;

});
parcelRegister("155hF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c9a5b621e5301b6$export$2e2bcd8739ae039; });

var $enmTs = parcelRequire("enmTs");
/** Built-in value references. */ var $0c9a5b621e5301b6$var$Symbol = (0, $enmTs.default).Symbol;
var $0c9a5b621e5301b6$export$2e2bcd8739ae039 = $0c9a5b621e5301b6$var$Symbol;

});

parcelRegister("drSKx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ca84417f00d2331$export$2e2bcd8739ae039; });

var $155hF = parcelRequire("155hF");
/** Used for built-in method references. */ var $9ca84417f00d2331$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9ca84417f00d2331$var$hasOwnProperty = $9ca84417f00d2331$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9ca84417f00d2331$var$nativeObjectToString = $9ca84417f00d2331$var$objectProto.toString;
/** Built-in value references. */ var $9ca84417f00d2331$var$symToStringTag = (0, $155hF.default) ? (0, $155hF.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9ca84417f00d2331$var$getRawTag(value) {
    var isOwn = $9ca84417f00d2331$var$hasOwnProperty.call(value, $9ca84417f00d2331$var$symToStringTag), tag = value[$9ca84417f00d2331$var$symToStringTag];
    try {
        value[$9ca84417f00d2331$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9ca84417f00d2331$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9ca84417f00d2331$var$symToStringTag] = tag;
        else delete value[$9ca84417f00d2331$var$symToStringTag];
    }
    return result;
}
var $9ca84417f00d2331$export$2e2bcd8739ae039 = $9ca84417f00d2331$var$getRawTag;

});

parcelRegister("gu259", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0011029f37088ab$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $c0011029f37088ab$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c0011029f37088ab$var$nativeObjectToString = $c0011029f37088ab$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $c0011029f37088ab$var$objectToString(value) {
    return $c0011029f37088ab$var$nativeObjectToString.call(value);
}
var $c0011029f37088ab$export$2e2bcd8739ae039 = $c0011029f37088ab$var$objectToString;

});


parcelRegister("2pW4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c2af6b3f01b3b43$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1c2af6b3f01b3b43$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $1c2af6b3f01b3b43$export$2e2bcd8739ae039 = $1c2af6b3f01b3b43$var$isObjectLike;

});






parcelRegister("hM6fK", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $cf0bc514c141a324$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $cf0bc514c141a324$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $cf0bc514c141a324$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("2cZpr"));
});
function $cf0bc514c141a324$var$ProductDetailsPage_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($cf0bc514c141a324$var$component, Props);
}
$cf0bc514c141a324$var$ProductDetailsPage_Lazy.displayName = "ProductDetailsPage_Lazy";
var $cf0bc514c141a324$export$513ccb98c53b8039 = $cf0bc514c141a324$var$component.preload;
var $cf0bc514c141a324$export$dd44f18ab656f3bb = $cf0bc514c141a324$var$ProductDetailsPage_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("2cZpr", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fsMVk")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("519fX")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fbQqy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("WepAH"))
]).then(function() {
    return parcelRequire("Tbt6s");
});

});



parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});

parcelRegister("8wpG4", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $63453ae6f4ab9cfc$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "$$delete", function () { return $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $63453ae6f4ab9cfc$export$a47fb462a08de82f(key) {
    if (typeof key === "object") {
        var variant = key.NAME;
        if (variant === "optimizeVariant") return "mkr_variant__" + key.VAL + "";
        if (variant === "clientId") return "mkr_client_id__" + key.VAL + "";
    } else {
        if (key === "legacyClientId") return "mkr_client_id";
        if (key === "optimizePreviousEvents") return "mkr_experience_impression";
    }
    var tmp;
    if (typeof key === "object") {
        var variant$1 = key.NAME;
        tmp = variant$1 === "optimizeVariant" ? "optimizeVariant" : variant$1 === "scrollRestoration" ? "scroll-" + key.VAL : variant$1 === "history" ? "history" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "clientId" ? "clientId" : variant$1 === "favorites" ? "favorites" + $2whNH.mapWithDefault(key.VAL, "", function(id) {
            return "-" + id;
        }) : variant$1 === "selectedMarket" ? "selectedMarket-" + key.VAL : "cart-" + key.VAL;
    } else tmp = key === "debuggerAllowed" ? "debuggerAllowed" : key === "navMenuConfig" ? "navMenuConfig" : key === "legacyClientId" ? "clientId" : key === "gridColumns" ? "gridColumns" : key === "optimizePreviousEvents" ? "optimizePreviousEvents" : "intro";
    return "smartnav__v" + String(2) + "__" + tmp;
}
function $63453ae6f4ab9cfc$export$3988ae62b71be9a3(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            return $2whNH.flatMap($loT9g.null_to_opt($2whNH.getWithDefault(storage, localStorage).getItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key))), function(value) {
                if (value === "") return;
                else return value;
            });
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$adaa4cf7ef1b65be(_storage, key, value) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).setItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key), value);
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
function $63453ae6f4ab9cfc$export$e30d7c331cdcc0b5(_storage, key) {
    while(true){
        var storage = _storage;
        try {
            $2whNH.getWithDefault(storage, localStorage).removeItem($63453ae6f4ab9cfc$export$a47fb462a08de82f(key));
            return;
        } catch (exn) {
            if (storage !== undefined) return;
            _storage = $loT9g.some(sessionStorage);
            continue;
        }
    }
}
var $63453ae6f4ab9cfc$export$83d89fbfd8236492 = 2;
 /* No side effect */ 
});

parcelRegister("38gYA", function(module, exports) {

$parcel$export(module.exports, "useScrollableContext", function () { return $247f49975e2c6903$export$c8bd6c217b070147; });
$parcel$export(module.exports, "make", function () { return $247f49975e2c6903$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $3tS2g = parcelRequire("3tS2g");

var $gWwbb = parcelRequire("gWwbb");

var $iXXhl = parcelRequire("iXXhl");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $efwy1 = parcelRequire("efwy1");

var $2XXXw = parcelRequire("2XXXw");
$gWwbb.polyfill();
var $247f49975e2c6903$var$context = /*#__PURE__*/ $g85JO.createContext({
    element: undefined
});
var $247f49975e2c6903$var$provider = $247f49975e2c6903$var$context.Provider;
function $247f49975e2c6903$var$Scrollable$Provider(Props) {
    var children = Props.children;
    var element = Props.element;
    return /*#__PURE__*/ $g85JO.createElement($247f49975e2c6903$var$provider, {
        value: {
            element: element
        },
        children: children
    });
}
$247f49975e2c6903$var$Scrollable$Provider.displayName = "Scrollable.Provider";
var $247f49975e2c6903$export$2881499e37b75b9a = {
    context: $247f49975e2c6903$var$context,
    provider: $247f49975e2c6903$var$provider,
    make: $247f49975e2c6903$var$Scrollable$Provider
};
function $247f49975e2c6903$export$c8bd6c217b070147(param) {
    return $g85JO.useContext($247f49975e2c6903$var$context);
}
function $247f49975e2c6903$var$Scrollable(Props) {
    var restorationId = Props.restorationId;
    var scrollToRef = Props.scrollToRef;
    var onScrollOpt = Props.onScroll;
    var childrenOpt = Props.children;
    var lockedOpt = Props.locked;
    var fwdRef = Props.fwdRef;
    var classNameOpt = Props.className;
    var onTouchStart = Props.onTouchStart;
    var onTouchMove = Props.onTouchMove;
    var onTouchEnd = Props.onTouchEnd;
    var scrollOffsetOpt = Props.scrollOffset;
    var defaultRestorationPosition = Props.defaultRestorationPosition;
    var inlineOpt = Props.inline;
    var styleOpt = Props.style;
    var stopPropagationOpt = Props.stopPropagation;
    var rememberScrollPositionOpt = Props.rememberScrollPosition;
    var onScroll = onScrollOpt !== undefined ? onScrollOpt : function onScroll(e, wasAutoScroll) {};
    var children = childrenOpt !== undefined ? $loT9g.valFromOption(childrenOpt) : null;
    var locked = lockedOpt !== undefined ? lockedOpt : false;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var scrollOffset = scrollOffsetOpt !== undefined ? scrollOffsetOpt : 0.0;
    var inline = inlineOpt !== undefined ? inlineOpt : false;
    var style = styleOpt !== undefined ? $loT9g.valFromOption(styleOpt) : {};
    var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
    var rememberScrollPosition = rememberScrollPositionOpt !== undefined ? rememberScrollPositionOpt : true;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var scrollRef = $g85JO.useRef(null);
    var isAutoScroll = $g85JO.useRef(false);
    var previousScroll = $g85JO.useRef(0);
    var match$1 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useScrollToTimeout = match$1.setTimeout;
    var match$2 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useRestoreFromPositionTimeout = match$2.setTimeout;
    var match$3 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useAutoScrollTimeout = match$3.setTimeout;
    var match$4 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useScrollLockTimeout = match$4.setTimeout;
    var mergedRef = fwdRef !== undefined ? (0, $iXXhl.default)(scrollRef, fwdRef) : scrollRef;
    var restoration = $2XXXw.useScrollRestoration(restorationId);
    $2whNH.forEach(scrollToRef, function(scrollTo) {
        scrollTo.current = function(el0) {
            useScrollToTimeout(function(param) {
                var el = scrollRef.current;
                if (el == null) return;
                var scrollTop;
                scrollTop = typeof el0 === "number" ? $2whNH.getWithDefault(defaultRestorationPosition, 0.0) : el0.TAG === /* Element */ 0 ? el0._0.offsetTop : el0._0;
                var el$1 = scrollRef.current;
                var options = {
                    top: scrollTop + scrollOffset,
                    left: 0.0,
                    behavior: "smooth"
                };
                if (!(el$1 == null)) el$1.scrollTo(options);
                if (restorationId !== undefined && rememberScrollPosition) {
                    previousScroll.current = scrollTop | 0;
                    return $2XXXw.setCurrentScroll(namespace, restorationId, {
                        TAG: /* Pixels */ 0,
                        _0: scrollTop | 0
                    });
                }
            }, 0);
        };
    });
    var onScroll$1 = function onScroll$1(param) {
        window.dispatchEvent(new Event("scroll"));
        $2whNH.map($loT9g.nullable_to_opt(scrollRef.current), function(el) {
            var scrollTop = el.scrollTop | 0;
            var isBlocking = $2XXXw.isBlockingOnScrollEvent(undefined);
            var isGreaterThanStart = $2whNH.mapWithDefault($2whNH.keep(defaultRestorationPosition, function(a) {
                return a > 0.0;
            }), true, function(start) {
                return scrollTop > start;
            });
            var isEnabled = !isBlocking && isGreaterThanStart;
            if (restorationId !== undefined && rememberScrollPosition && isEnabled) {
                previousScroll.current = scrollTop;
                return $2XXXw.setCurrentScroll(namespace, restorationId, {
                    TAG: /* Pixels */ 0,
                    _0: scrollTop
                });
            }
        });
    };
    var restoreFromLock = function restoreFromLock(lock) {
        return $2whNH.getWithDefault($2whNH.map($loT9g.nullable_to_opt(scrollRef.current), function(scrollEl) {
            var lockEl = lock.element;
            if ($3tS2g.isDescendent(scrollEl, lockEl)) {
                useScrollLockTimeout(function(param) {
                    var currentScrollPosition = scrollEl.scrollTop;
                    var currentElementTop = lockEl.getBoundingClientRect().top;
                    var originalElementTop = lock.boundingClientRect.top;
                    var amountToScroll = currentElementTop - originalElementTop;
                    var newScrollPosition = currentScrollPosition + amountToScroll;
                    scrollEl.scrollTop = newScrollPosition;
                    onScroll$1(undefined);
                }, 0);
                return true;
            } else return false;
        }), false);
    };
    var restoreFromPosition = function restoreFromPosition1(retryOpt, el, position) {
        var retry = retryOpt !== undefined ? retryOpt : 0;
        if (typeof position === "number") {
            var targetScroll = Math.max(scrollOffset, $2whNH.getWithDefault(defaultRestorationPosition, 0.0)) | 0;
            var scrollTop = $2XXXw.getClosestBreakingPoint(previousScroll.current, targetScroll);
            el.scrollTop = scrollTop;
            return;
        }
        if (position.TAG !== /* Pixels */ 0) return;
        var scrollTop$1 = Math.max(scrollOffset, position._0);
        var height = $2whNH.getWithDefault($2whNH.map($2whNH.map($i7mYY.get(Array.prototype.slice.call(el.children), 0), function(prim) {
            return prim.getBoundingClientRect();
        }), function(prim) {
            return prim.height;
        }), 100000);
        if (scrollTop$1 === 0 || scrollTop$1 <= height || retry > 4) {
            el.scrollTop = scrollTop$1;
            return;
        } else return useRestoreFromPositionTimeout(function(param) {
            restoreFromPosition(retry + 1 | 0, el, position);
        }, 16);
    };
    var setisAutoScroll = function setisAutoScroll(param) {
        isAutoScroll.current = true;
        useAutoScrollTimeout(function(param) {
            isAutoScroll.current = false;
        }, 100);
    };
    $g85JO.useLayoutEffect(function() {
        var el = scrollRef.current;
        if (!(el == null)) {
            var lock = restoration.lock;
            if (lock !== undefined) {
                if (!restoreFromLock(lock)) restoreFromPosition(undefined, el, restoration.position);
            } else {
                setisAutoScroll(undefined);
                restoreFromPosition(undefined, el, restoration.position);
            }
        }
    }, [
        restoration
    ]);
    var positionClassName = inline ? "" : "absolute top-0 left-0";
    var tmp = {
        ref: $5bEXW.Ref.domRef(mergedRef),
        "aria-label": "scrollable content",
        className: $1TRFX.make([
            className,
            $ezf3v.prefix(positionClassName),
            $ezf3v.prefix("w-full h-full overflow-x-hidden no-overflow-anchoring overscroll-none"),
            locked ? $ezf3v.prefix("overflow-y-hidden touch-none") : $ezf3v.prefix("overflow-y-scroll touch-pan-y")
        ]),
        role: "region",
        style: style,
        onScroll: function onScroll1(e) {
            if (stopPropagation) {
                e.preventDefault();
                e.stopPropagation();
            }
            onScroll$1(undefined);
            $iv6Yc._2(onScroll, e, isAutoScroll.current);
        }
    };
    if (onTouchEnd !== undefined) tmp.onTouchEnd = $loT9g.valFromOption(onTouchEnd);
    if (onTouchMove !== undefined) tmp.onTouchMove = $loT9g.valFromOption(onTouchMove);
    if (onTouchStart !== undefined) tmp.onTouchStart = $loT9g.valFromOption(onTouchStart);
    var tmp$1 = {
        dataTestId: "scrollable",
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp, children)
    };
    if (restorationId !== undefined) tmp$1.dataId = restorationId;
    return /*#__PURE__*/ $g85JO.createElement($247f49975e2c6903$var$Scrollable$Provider, {
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$1),
        element: $loT9g.nullable_to_opt(scrollRef.current)
    });
}
$247f49975e2c6903$var$Scrollable.displayName = "Scrollable";
var $247f49975e2c6903$export$dd44f18ab656f3bb = $247f49975e2c6903$var$Scrollable;
 /*  Not a pure module */ 
});
parcelRegister("3tS2g", function(module, exports) {

$parcel$export(module.exports, "isDescendent", function () { return $288dfedeedc2f681$export$965a0cda204ba1d7; });
// Generated by ReScript, PLEASE EDIT WITH CARE
function $288dfedeedc2f681$export$965a0cda204ba1d7(ancestor, _descendent) {
    while(true){
        var descendent = _descendent;
        var parent = descendent.parentElement;
        if (parent == null) return false;
        if (parent === ancestor) return true;
        _descendent = parent;
        continue;
    }
}
function $288dfedeedc2f681$export$ec70bc1e11cea5ad(options, element) {
    element.scrollIntoView(options);
}
 /* No side effect */ 
});


parcelRegister("4Q2zg", function(module, exports) {

$parcel$export(module.exports, "useEdgeSwipeDetector", function () { return $385e02a886c671c9$export$11f9a379a9296a15; });
$parcel$export(module.exports, "useEdgeSwipeDetectorImmediate", function () { return $385e02a886c671c9$export$9b8be4be2f76c0b6; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $biidj = parcelRequire("biidj");
var $385e02a886c671c9$export$66e76ce6d60c3fb = function getTouchX(e) {
    return e.touches[0].pageX;
};
function $385e02a886c671c9$export$11f9a379a9296a15(param) {
    var windowWidth = $biidj.useWindowWidth(undefined, undefined, undefined, undefined);
    var lastDetectionTime = $g85JO.useRef(undefined);
    var touchStartX = $g85JO.useRef(undefined);
    var touchEndX = $g85JO.useRef(undefined);
    var didEdgeSwipe = function didEdgeSwipe(param) {
        return $2whNH.getWithDefault($2whNH.map(lastDetectionTime.current, function(t) {
            return Date.now() - t < 200.0;
        }), false);
    };
    $g85JO.useEffect(function() {
        var onTouchStart = function onTouchStart(e) {
            var x = $385e02a886c671c9$export$66e76ce6d60c3fb(e);
            touchStartX.current = x;
        };
        var onTouchMove = function onTouchMove(e) {
            var x = $385e02a886c671c9$export$66e76ce6d60c3fb(e);
            touchEndX.current = x;
        };
        var onTouchEnd = function onTouchEnd(e) {
            var match = touchStartX.current;
            var match$1 = touchEndX.current;
            if (match !== undefined && match$1 !== undefined) {
                var leftEdgeSwipe = match < 20 && (match$1 - match | 0) > 20;
                var rightEdgeSwipe = (windowWidth - match | 0) < 20 && (match$1 - match | 0) < -20;
                if (leftEdgeSwipe || rightEdgeSwipe) lastDetectionTime.current = Date.now();
            }
            touchStartX.current = undefined;
        };
        document.addEventListener("touchstart", onTouchStart, true);
        document.addEventListener("touchmove", onTouchMove, true);
        document.addEventListener("touchend", onTouchEnd, true);
        return function(param) {
            document.removeEventListener("touchstart", onTouchStart, true);
            document.removeEventListener("touchmove", onTouchMove, true);
            document.removeEventListener("touchend", onTouchEnd, true);
        };
    }, []);
    return didEdgeSwipe;
}
function $385e02a886c671c9$export$9b8be4be2f76c0b6(param) {
    var windowWidth = $biidj.useWindowWidth(undefined, undefined, undefined, undefined);
    var match = $g85JO.useState(function() {
        return false;
    });
    var setDidEdgeSwipe = match[1];
    $g85JO.useEffect(function() {
        var onTouchStart = function onTouchStart(e) {
            var x = $385e02a886c671c9$export$66e76ce6d60c3fb(e);
            var isLeftEdge = x <= 20;
            var isRightEdge = (windowWidth - x | 0) <= 20;
            if (isLeftEdge || isRightEdge) return $iv6Yc._1(setDidEdgeSwipe, function(param) {
                return true;
            });
        };
        var onTouchEnd = function onTouchEnd(e) {
            $iv6Yc._1(setDidEdgeSwipe, function(param) {
                return false;
            });
        };
        document.addEventListener("touchstart", onTouchStart, true);
        document.addEventListener("touchend", onTouchEnd, true);
        return function(param) {
            document.removeEventListener("touchstart", onTouchStart, true);
            document.removeEventListener("touchend", onTouchEnd, true);
        };
    }, []);
    return match[0];
}
var $385e02a886c671c9$export$6683742126cd10b5 = 20;
 /* react Not a pure module */ 
});

parcelRegister("dJhID", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9fed38edae7c024d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $6Tsgf = parcelRequire("6Tsgf");

var $hmsbi = parcelRequire("hmsbi");

var $hPrj9 = parcelRequire("hPrj9");

var $3GntQ = parcelRequire("3GntQ");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $75ZqT = parcelRequire("75ZqT");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $4QdUt = parcelRequire("4QdUt");
var $9fed38edae7c024d$export$20dc868c9a130faa = $75ZqT.$$Error.fromRescriptWithNewMessage;
var $9fed38edae7c024d$var$_ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $hPrj9._)(_ErrorBoundary, _React_Component);
    var _super = (0, $3GntQ._)(_ErrorBoundary);
    function _ErrorBoundary(props) {
        (0, $6Tsgf._)(this, _ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: false,
            errorInfo: null
        };
        return _this;
    }
    (0, $hmsbi._)(_ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                // If we detect that the error is a rescript exception, we try to extract information out of it,
                // and create a new error object with it's RE_EXN_ID as the message.
                if (typeof error.RE_EXN_ID == "string" && typeof error.Error == "object") error = $9fed38edae7c024d$export$20dc868c9a130faa(error, error.RE_EXN_ID);
                // Do nothing if the error is thrown by parcel script loader.
                // This error usually indicates network issues.
                if (error.message.includes("Failed to fetch dynamically imported module:") || error.message.includes("Cannot find module") || error.message.includes("Could not resolve bundle with id")) return;
                this.setState({
                    error: error,
                    errorInfo: errorInfo
                });
                if (this.props.onError) this.props.onError(error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.error) return this.props.renderFallback ? this.props.renderFallback(this.state.error, this.state.errorInfo) : null;
                else return this.props.children;
            }
        }
    ]);
    return _ErrorBoundary;
}($g85JO.Component);
function $9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary(Props) {
    return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$_ErrorBoundary, Props);
}
$9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary.displayName = "ErrorBoundary.RawErrorBoundary";
var $9fed38edae7c024d$export$e022a45c7a286b77 = {
    make: $9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary
};
function $9fed38edae7c024d$export$b42e70ddca33ff5b(str) {
    if (str !== "") return str;
}
function $9fed38edae7c024d$var$ErrorBoundary$ReportOnce(Props) {
    var error = Props.error;
    var redirect = Props.redirect;
    var componentStack = Props.componentStack;
    var message = Props.message;
    $g85JO.useEffect(function() {
        $4QdUt.critical2(error, {
            message: message,
            componentStack: componentStack
        });
        var timeout = redirect !== undefined ? $loT9g.some(setTimeout(function(param) {
            $iv6Yc._1(redirect, undefined);
        }, 0)) : undefined;
        return function(param) {
            $2whNH.forEach(timeout, function(id) {
                clearTimeout(id);
            });
        };
    }, []);
    return null;
}
$9fed38edae7c024d$var$ErrorBoundary$ReportOnce.displayName = "ErrorBoundary.ReportOnce";
var $9fed38edae7c024d$export$f2fa74dfba7f4e57 = {
    make: $9fed38edae7c024d$var$ErrorBoundary$ReportOnce
};
function $9fed38edae7c024d$var$ErrorBoundary(Props) {
    var componentName = Props.componentName;
    var redirect = Props.redirect;
    var children = Props.children;
    var renderFallback = function renderFallback(internalError, info) {
        var cause = $75ZqT.$$Error.fromRescript(internalError);
        var rootCause = $75ZqT.$$Error.getRootCause(cause);
        var rootCauseName = rootCause.name;
        var rootCauseMessage = rootCause.message;
        var culprit = $2whNH.getWithDefault($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.map(info.componentStack, function(__x) {
            return __x.replace(/\n/g, "");
        }), function(__x) {
            return __x.split(" in ");
        }), function(__x) {
            return $i7mYY.get(__x, 1);
        }), function(__x) {
            return __x.replace(/\(([^\)]+)\)/g, "");
        }), function(prim) {
            return prim.trim();
        }), $9fed38edae7c024d$export$b42e70ddca33ff5b), function(culprit) {
            return "<" + culprit + "> crashed, " + componentName + " caught";
        }), componentName + " caught a crash");
        var rootCauseMessage$1 = rootCauseName !== undefined ? rootCauseMessage !== undefined ? "RC: " + rootCauseName + " " + rootCauseMessage : "RC: " + rootCauseName : rootCauseMessage !== undefined ? "RC: " + rootCauseMessage : undefined;
        var message = $i7mYY.keepMap([
            culprit,
            rootCauseMessage$1
        ], function(a) {
            return a;
        }).join(", ");
        var error = $75ZqT.$$Error.fromStringWithCause(message, rootCause);
        var tmp = {
            error: error,
            componentStack: info.componentStack,
            message: message
        };
        if (redirect !== undefined) tmp.redirect = $loT9g.valFromOption(redirect);
        return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$ErrorBoundary$ReportOnce, tmp);
    };
    return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary, {
        children: children,
        renderFallback: renderFallback
    });
}
$9fed38edae7c024d$var$ErrorBoundary.displayName = "ErrorBoundary";
var $9fed38edae7c024d$export$dd44f18ab656f3bb = $9fed38edae7c024d$var$ErrorBoundary;
 /*  Not a pure module */ 
});

parcelRegister("3sSBX", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $285e594aca7fdb2f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $dzlIC = parcelRequire("dzlIC");

var $5tfgg = parcelRequire("5tfgg");

var $hBcYV = parcelRequire("hBcYV");

var $eIwLU = parcelRequire("eIwLU");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");
function $285e594aca7fdb2f$var$Launcher(Props) {
    var style = Props.style;
    var isNestedOpt = Props.isNested;
    var highlightedCategoryId = Props.highlightedCategoryId;
    var categories = Props.categories;
    var forceStyle = Props.forceStyle;
    var centeredOpt = Props.centered;
    var paddedOpt = Props.padded;
    var classNameOpt = Props.className;
    var dataTestId = Props.dataTestId;
    var sliderDataTestId = Props.sliderDataTestId;
    var sliderInsetMargin = Props.sliderInsetMargin;
    var slidesPerView = Props.slidesPerView;
    var onItemMouseEnter = Props.onItemMouseEnter;
    var onItemClick = Props.onItemClick;
    var onTrackClick = Props.onTrackClick;
    var onItemRendered = Props.onItemRendered;
    var ariaLabel = Props.ariaLabel;
    var tabIndex = Props.tabIndex;
    var theme = Props.theme;
    var isNested = isNestedOpt !== undefined ? isNestedOpt : false;
    var centered = centeredOpt !== undefined ? centeredOpt : false;
    var padded = paddedOpt !== undefined ? paddedOpt : true;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var match = $hBcYV.useRouter(undefined);
    var listPageType = match.listPageType;
    var goTo = match.goTo;
    var match$1 = $9pMGg.use(undefined);
    var onClick = match$1.onLauncherItemClick;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, categories);
    var match$2 = $8E2YL.use(undefined).config;
    var settings = match$2.settings;
    $g85JO.useEffect(function() {
        var isAnyQuickViewStories = $i7mYY.some(categories, $1xf0g.isQuickViewStoriesEnabled);
        if (isAnyQuickViewStories && !isNested) $iv6Yc._1($b8WNX.preload, undefined);
    }, [
        categories
    ]);
    var match$3 = settings.mkrBio;
    var border = match$3 !== undefined && !isNested ? /* BorderBottom */ 1 : /* BorderNone */ 0;
    var match$4 = settings.mkrBio;
    var indicatorThickness = match$4 !== undefined ? /* Sm */ 1 : /* Normal */ 0;
    var match$5 = settings.mkrBio;
    var height = match$5 !== undefined ? /* Lg */ 1 : /* Normal */ 0;
    var activeCategoryPath = $i7mYY.map($2whNH.mapWithDefault($2whNH.map(activeCategory, function(category) {
        return category.id;
    }), [], function(id) {
        return $1xf0g.getCategoryPathById(categories, id);
    }), function(category) {
        return category.id;
    });
    var activeCategoryId = $2whNH.map($i7mYY.getBy(categories, function(category) {
        return activeCategoryPath.includes(category.id);
    }), function(category) {
        return category.id;
    });
    var match$6 = settings.indexNode;
    var activeCategoryId$1 = activeCategoryId !== undefined ? activeCategoryId : match$6 !== undefined && match$6.visibleInMenuBar && match.route !== /* NotRendered */ 0 && !isNested ? match$6.id : undefined;
    var activeCategoryId$2 = $2whNH.keep(activeCategoryId$1, function(param) {
        if ($7bjme.notequal(listPageType, /* History */ 1)) return $7bjme.notequal(listPageType, /* Favorites */ 0);
        else return false;
    });
    var layout = forceStyle !== undefined ? forceStyle : isNested ? settings.nestedCategoryLayout : settings.categoryLayout;
    var size = isNested ? settings.nestedCategorySize : settings.categorySize;
    var onClick$1 = $g85JO.useCallback($iv6Yc.__1(onClick), [
        onClick
    ]);
    var onClick$2 = $2whNH.getWithDefault(onItemClick, onClick$1);
    var onMouseEnter = $2whNH.getWithDefault(onItemMouseEnter, function(param) {});
    var partial_arg = false;
    var items = $i7mYY.map(categories, function(param) {
        return $5tfgg.fromCategory(partial_arg, param);
    });
    var match$7 = settings.mkrBio;
    var match$8 = items.length;
    var items$1 = match$7 !== undefined && match$8 === 1 ? [] : items;
    var onChange = function onChange(id) {
        var category = $i7mYY.getBy(categories, function(category) {
            return category.id === id;
        });
        if (category === undefined) return;
        $2whNH.forEach(onTrackClick, function(onTrackClick) {
            $iv6Yc._1(onTrackClick, category);
        });
        var match = $1xf0g.Link.getCardLink(category);
        if (match === undefined) return $iv6Yc._1(onClick$2, category);
        switch(match.TAG | 0){
            case /* URL */ 0:
                return;
            case /* Category */ 1:
                var match$1 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* Category */ 0,
                            _0: match$1.categoryId
                        },
                        viewPLP: false,
                        filters: match$1.filters,
                        sort: undefined
                    }
                });
            case /* Product */ 2:
                var match$2 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: undefined,
                        productCategoryId: match$2.productCategoryId,
                        productId: match$2.productId,
                        variantId: match$2.variantId,
                        zoomedPhotoIndex: undefined
                    }
                });
            case /* StoreCategory */ 3:
                var match$3 = match._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* ListPage */ 1,
                    _0: {
                        listPageType: {
                            TAG: /* StoreCategory */ 2,
                            _0: {
                                categoryId: match$3.categoryId,
                                sourceNodeId: category.id
                            }
                        },
                        viewPLP: false,
                        filters: undefined,
                        sort: match$3.sortBy
                    }
                });
            case /* CustomAction */ 4:
                var match$4 = match._0;
                $dzlIC.triggerCustomFunctionWithoutProducts(match$4.code, match$4.name, undefined, undefined);
                return;
        }
    };
    var onHover = function onHover(id) {
        var category = $i7mYY.getBy(categories, function(category) {
            return category.id === id;
        });
        if (category !== undefined) return $iv6Yc._1(onMouseEnter, category);
    };
    if ($7bjme.equal(items$1, [])) return null;
    var tmp = {
        items: items$1,
        layout: layout,
        size: size,
        theme: theme,
        centered: centered,
        verticallyCenter: layout === /* Labels */ 0,
        className: className,
        onChange: onChange,
        onHover: onHover,
        border: border,
        indicatorThickness: indicatorThickness,
        height: height
    };
    if (highlightedCategoryId !== undefined) tmp.highlightValue = $loT9g.valFromOption(highlightedCategoryId);
    if (activeCategoryId$2 !== undefined) tmp.activeValue = $loT9g.valFromOption(activeCategoryId$2);
    if (dataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(dataTestId);
    if (sliderDataTestId !== undefined) tmp.sliderDataTestId = $loT9g.valFromOption(sliderDataTestId);
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    var tmp$1 = padded ? undefined : 0;
    if (tmp$1 !== undefined) tmp.padding = tmp$1;
    if (onItemRendered !== undefined) tmp.onItemRendered = $loT9g.valFromOption(onItemRendered);
    var tmp$2 = padded ? undefined : /* Zero */ 3;
    if (tmp$2 !== undefined) tmp.gap = $loT9g.valFromOption(tmp$2);
    if (slidesPerView !== undefined) tmp.slidesPerView = slidesPerView;
    if (sliderInsetMargin !== undefined) tmp.sliderInsetMargin = $loT9g.valFromOption(sliderInsetMargin);
    if (ariaLabel !== undefined) tmp.ariaLabel = $loT9g.valFromOption(ariaLabel);
    if (tabIndex !== undefined) tmp.tabIndex = $loT9g.valFromOption(tabIndex);
    return /*#__PURE__*/ $g85JO.createElement($eIwLU.make, tmp);
}
$285e594aca7fdb2f$var$Launcher.displayName = "Launcher";
var $285e594aca7fdb2f$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($285e594aca7fdb2f$var$Launcher);
var $285e594aca7fdb2f$export$aa541d093b11ace2 = $285e594aca7fdb2f$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});

})();
//# sourceMappingURL=BottombarApp.bs.d84ef223.js.map
